import { Navigate, Outlet, generatePath, useParams } from 'react-router-dom'
import { useEditOrderItem, useOrdering } from 'hooks'
import { TypeRoute } from 'core/TypeRoute'
import { Box } from '@mui/material'
import { CartDrawer } from 'components/ordering/CartDrawer'
import { EditOrderItemDialog } from 'components/ordering/EditOrderItemDialog'

export const OrderingLayout = () => {
  const { order } = useOrdering()
  const { storeId } = useParams()
  const { editingOrderItem } = useEditOrderItem()
  return order ? (
    <Box
      sx={{
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Outlet />
      <CartDrawer />
      {editingOrderItem && <EditOrderItemDialog />}
    </Box>
  ) : (
    // TODO: currently if order is not created by clicking on the 3 options on Info screen
    // we will not proceed further. However we should consider using local storage to
    // store the order and retrieve it here.
    <Navigate
      to={generatePath(TypeRoute.StoreInfo, { storeId: storeId ?? '' })}
      replace={true}
    />
  )
}
